import type { RecordValue } from "../types";

export const isRecord = (value: unknown): value is RecordValue => {
  return typeof value === "object" && value !== null && !Array.isArray(value);
};
